import { driver } from 'driver.js'

/* @ngInject */
function SidebarMenuController ($rootScope, $scope, $state, $timeout, $window, $q, $translate, NotificationsCentralService, NotificationsService, UserService, CustomerConfigurationsService, SegmentService, UiElementViewLogService, ModalService, UdsModalService) {
  const getAppBannerDialogController = () => import('../../dialogs/app-banner-modal/app-banner-modal.controller')
  const getAskForSupportDialogController = () => $q.when(import('../../../core/dialogs/ask-for-support/ask-for-support-dialog.controller'))
  const getModulesPricingDialogController = () => import('../../dialogs/modules-pricing/modules-pricing-dialog.controller')

  $scope.showDropdown = false
  $scope.expanded = false
  $scope.user = {}
  $scope.avatarActionElement = null
  $scope.showAvatarDropdown = false
  $scope.avatarDropdown = null
  $scope.hasNotification = false
  $scope.notificationBarIsOpen = false
  $scope.avatarUrl = ''
  $scope.hideSidebarMenu = false
  $scope.showAppBannerText = false
  $scope.notHasIntercomFeature = false

  $scope.helpActionElement = null
  $scope.helpDropdown = null
  $scope.showHelpDropdown = false

  $scope.hideModulePricingInfo = false
  $scope.showReferAndEarnButton = false

  // Provisional statement to help hide the "refer and earn" button for Sebrae environment
  // This "refer and earn" button will be removed later for all environments
  $scope.isSebraeEnvironment = false
  const sebraeIds = [305, 632, 726, 1100, 1144, 1196, 1211, 1292, 1374, 1626, 1645, 1663, 1732, 1787, 1791, 1795, 1821, 1831, 1832, 1837, 1843, 1846, 1857, 1861]

  var sidebarAnimationTimeout = null
  let dontShowRepositories = false
  let brandSidebarTour = null

  const api = {
    getAppBannerDialogController,
    getAskForSupportDialogController,
    getModulesPricingDialogController,
    _expandSidebar,
    _collapseSidebar,
    _shouldShowSettingsBtn,
    _goToSettingsPage,
    _handleAvatarClickAway,
    _handleHelpClickAway,
    _handleSidebarColor,
    _getInitialData,
    _getUnreadNotifications,
    _handleFeatureClick,
    _getUserImage,
    _validateReferAndEarnFlag,
    _handleAppBannerTextViewed,
    _setSidebar,
    _setSidebarClass,
    _shouldShowWhatsappCommunityBtn,
    _isSebraeEnvironment,
    _enableFilesModule,
    _handleMiaBrandSidebarTour
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getInitialData().then(api._handleMiaBrandSidebarTour)
    api._validateReferAndEarnFlag()

    UiElementViewLogService.getElementViewLog('appBannerText').then(api._handleAppBannerTextViewed)

    $timeout(() => {
      const sidebarElement = $('sidebar-menu .sidebar-menu')
      sidebarElement.on('mouseenter', api._expandSidebar)
      sidebarElement.on('mouseleave', api._collapseSidebar)
      api._handleSidebarColor(sidebarElement[0])
      $scope.hideModulePricingInfo = false
    }, 0, true)

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.notHasIntercomFeature = !features['GENERAL.INTERCOM_CHAT']
    })
  }

  async function _handleMiaBrandSidebarTour () {
    const canViewTour = $rootScope.isUserSysAdminAdminDesigner() && $scope.pricingPackageId === 4
    const miaBrandSidebarTourWasViewed = await UiElementViewLogService.getElementViewLog('miaBrandSidebarTour')
    if (!miaBrandSidebarTourWasViewed && canViewTour) {
      $timeout(() => {
        brandSidebarTour = driver({
          allowClose: false
        })
        brandSidebarTour.highlight({
          element: '#brand',
          popover: {
            title: $translate.instant('miaBrandSidebarTour.title'),
            description: $translate.instant('miaBrandSidebarTour.description'),
            side: 'right',
            align: 'center'
          }
        })
      }, 300, false)
      UiElementViewLogService.createElementViewLog('miaBrandSidebarTour')
    }
  }

  function _handleAppBannerTextViewed (appBannerWasViewed) {
    if (!appBannerWasViewed && $rootScope.isUser()) { $scope.showAppBannerText = true }
  }

  const deregisterMobileLoadPreviewsCompanies = $scope.$on('mobile.load-previews-companies', (e, res) => {
    $scope.previewsCompaniesMobile = res.companies
    $scope.previewsCompaniesMobileCount = res.count
  })

  const deregisterReloadUnreadNotifications = $scope.$on('reloadUnreadNotifications', function () {
    _getUnreadNotifications()
  })

  const deregisterNotificationBarOpen = $scope.$on('notificationBarToggle', function (e, isOpen) {
    $scope.notificationBarIsOpen = isOpen
  })

  $scope.$on('$destroy', () => {
    deregisterMobileLoadPreviewsCompanies()
    deregisterReloadUnreadNotifications()
    deregisterNotificationBarOpen()
  })

  function _getUserImage () {
    return UserService.getUserProfileImage($scope.user.id)
  }

  function _expandSidebar () {
    sidebarAnimationTimeout = $timeout(() => {
      if (!$scope.showAvatarDropdown && !$scope.showHelpDropdown && !$scope.notificationBarIsOpen) {
        $scope.expanded = true
      }
    }, 200, true)
  }

  function _collapseSidebar () {
    $timeout.cancel(sidebarAnimationTimeout)
    $timeout(() => {
      $scope.expanded = false
      $scope.showDropdown = false
    }, 0, true)
  }

  function _getInitialData () {
    return Promise.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getUser(),
      $rootScope.getCompanyFeatures()
    ]).then(([companyFeaturesAndAddons, user, companyFeatures]) => {
      $scope.features = companyFeaturesAndAddons.features
      $scope.pricingPackageId = companyFeaturesAndAddons.pricingPackageId
      $scope.user = user
      $scope.avatarUrl = api._getUserImage()

      api._setSidebar(companyFeatures)
      NotificationsService.getUnreadNotificationsCount().then((notificationsCount) => {
        $scope.hasNotification = notificationsCount.count > 0
      })
    })
  }

  function _handleSidebarColor (sidebarElement) {
    CustomerConfigurationsService.getOneConfigurationByType('COMPANY_PRIMARY_COLOR', 'STRING')
      .then(({ value }) => {
        const color = value || $rootScope.customerColor || '#00abc8'
        const activeColor = color + '33'
        const hoverColor = color + '14'

        sidebarElement.style.setProperty('--mySidebarColorActive', activeColor)
        sidebarElement.style.setProperty('--mySidebarColorHover', hoverColor)
      })
  }

  function _getUnreadNotifications () {
    NotificationsService.getUnreadNotificationsCount().then(res => {
      $scope.hasNotification = res.count > 0
    })
  }

  // provisional function to help hide the "refer and earn" button for Sebrae environment
  function _isSebraeEnvironment (environmentIds) {
    return environmentIds.includes($rootScope.oUser.customerCompanyId)
  }
  // provisional function call
  $scope.isSebraeEnvironment = api._isSebraeEnvironment(sebraeIds)

  $scope.openAvatarDropdown = (e) => {
    if (!$scope.avatarActionElement || !$scope.avatarDropdown) {
      $scope.avatarActionElement = e.currentTarget
      $scope.avatarDropdown = $('.sidebar-avatar-dropdown')[0]

      document.addEventListener('click', api._handleAvatarClickAway)
    }

    api._collapseSidebar()
    $scope.showAvatarDropdown = !$scope.showAvatarDropdown
    $scope.avatarDropdown.toggleDropdown($scope.showAvatarDropdown)
  }

  $scope.openHelpDropdown = (event) => {
    if (!$scope.helpActionElement || !$scope.helpDropdown) {
      $scope.helpActionElement = event.currentTarget
      $scope.helpDropdown = $('.sidebar-help-dropdown')[0]

      document.addEventListener('click', api._handleHelpClickAway)
    }

    api._collapseSidebar()
    $scope.showHelpDropdown = !$scope.showHelpDropdown
    $scope.helpDropdown.toggleDropdown($scope.showHelpDropdown)
  }

  function _handleAvatarClickAway (event) {
    const isActionElement = $scope.avatarActionElement.contains(event.target)

    if ($scope.showAvatarDropdown && !isActionElement) {
      $scope.showAvatarDropdown = false
      $scope.avatarDropdown.toggleDropdown($scope.showAvatarDropdown)
    }
  };

  function _handleHelpClickAway (event) {
    const isActionElement = $scope.helpActionElement.contains(event.target)

    if ($scope.showHelpDropdown && !isActionElement) {
      $scope.showHelpDropdown = false
      $scope.helpDropdown.toggleDropdown($scope.showHelpDropdown)
    }
  };

  $scope.openNotificationsCentral = function (event) {
    event.preventDefault()
    event.stopPropagation()
    api._collapseSidebar()

    if ($scope.notificationBarIsOpen) {
      NotificationsCentralService.close()
    } else {
      NotificationsCentralService.open(true)
    }
  }

  $scope.openPrivacyPolicy = () => {
    $window.open('https://www.deskfy.io/pol%C3%ADtica-de-privacidade', '_blank')
  }

  function _shouldShowSettingsBtn () {
    return $rootScope.isUserSysAdminAdmin() ||
      ($rootScope.oUserCompanyConfigurations &&
      !$rootScope.isUser() &&
      $scope.features &&
      ($scope.features['ARTS.ACCESS'] || $scope.features['POSTS.ACCESS']))
  }
  $scope.shouldShowSettingsBtn = api._shouldShowSettingsBtn

  function _shouldShowWhatsappCommunityBtn () {
    return !$rootScope.isUser()
  }
  $scope.shouldShowWhatsappCommunityBtn = api._shouldShowWhatsappCommunityBtn

  $scope.openWhatsappCommunity = () => {
    $window.open('https://chat.whatsapp.com/G9u8YDjktlz4KM63x74mnc', '_blank')
    SegmentService.track('general-community-click')
  }

  function _goToSettingsPage () {
    if ($rootScope.isUserSysAdminAdmin()) {
      $state.go('admin.general')
    } else {
      if ($scope.features['ARTS.ACCESS']) {
        $state.go('admin.formats')
      } else if ($scope.features['POSTS.ACCESS']) {
        $state.go('admin.postCategories')
      }
    }
  }
  $scope.goToSettings = api._goToSettingsPage

  $scope.isModuleSubpage = function (moduleName) {
    const currentPage = $state.current.name
    const isSubPage = currentPage.indexOf(`${moduleName}.`) > -1

    return isSubPage
  }

  $scope.isActiveMenu = function (stateName) {
    return $state.current.name === stateName
  }

  $scope.enableBrandModule = () => {
    const userConfig = $rootScope.oUserCompanyConfigurations

    if (!$scope.features) {
      return false
    }

    const shouldShowModule = ($scope.features[String('ARTS.ACCESS')] || (!$scope.features[String('ARTS.ACCESS')] && $scope.features[String('BRAND.ACCESS')])) && $scope.features[String('ARTS.CUSTOMIZABLE_ARTS')]

    return $rootScope.isUser() ? shouldShowModule && userConfig.ENABLE_BRAND_ASSETS_MODULE_USER : shouldShowModule
  }

  function _enableFilesModule () {
    const userHasAccess = $rootScope.oUserCompanyConfigurations?.ENABLE_USER_DAM_MODULE

    // Temporary code - Check for 3 months after DAM migration only *
    const targetCompaniesIds = [
      1809, 1790, 1725, 1767, 1816, 1846, 1807, 1794, 1651, 1679, 1749, 1800, 1768, 1812, 1538, 1700, 1851, 1850, 1582, 1523, 1831, 920, 1777, 1614, 1838, 1844, 1699,
      1804, 1663, 1826, 1747, 1682, 1669, 1855, 1649, 1423, 1824, 1619, 1732, 1680, 1823, 1754, 1667, 1752, 1837, 765, 1852, 1579, 1656, 1196, 1787, 1753, 1748, 1335,
      634, 1595, 1645, 1704, 1613, 1625, 1587, 1765, 1783, 1586, 1644, 229, 1626, 478, 1258, 390, 1710, 1591, 651, 1796, 1633, 688, 1644, 634, 1578, 1742, 1, 279, 339,
      1876, 1734, 1627
    ]

    const isUser = $rootScope.isUser()
    const isCompanyOnTargetCompanies = !!targetCompaniesIds.find(companyId => companyId === $scope.user.customerCompanyId)
    const companyHasMigratedDAM = $rootScope.oUserCompanyFeatures?.includes('DAM_REPOSITORY_MIGRATION')

    if (companyHasMigratedDAM && isUser && userHasAccess && isCompanyOnTargetCompanies) {
      dontShowRepositories = true
      return true
    }
    // *****

    return false
  }

  $scope.handleReferAndEarnClick = function (link) {
    UiElementViewLogService.createElementViewLog('referAndEarn')
    SegmentService.track('general-refer-to-win-click')
    $scope.showReferAndEarnButton = false
    window.open(link, '_blank')
  }

  function _validateReferAndEarnFlag () {
    UiElementViewLogService.getElementViewLog('referAndEarn')
      .then((buttonWasViewed) => {
        if (!buttonWasViewed) {
          $scope.showReferAndEarnButton = true
        } else {
          $scope.showReferAndEarnButton = false
        }
      })
  }

  $scope.closeSidebarMenu = function () {
    $('.sidebar-menu').transition('slide right')
  }

  $scope.changeToWorkflow = function () {
    $state.go('workflow')
    api._handleFeatureClick()
  }

  function _handleFeatureClick () {
    NotificationsCentralService.close()
    if (brandSidebarTour) {
      brandSidebarTour.destroy()
    }
  }
  $scope.handleFeatureClick = api._handleFeatureClick

  $scope.goToAnalytics = () => {
    api._handleFeatureClick()

    const isWorkflow = $scope.pricingPackageId === 4
    const defaultAnalyticsPage = isWorkflow ? 'workflow-overview' : 'overview'

    $state.go('analytics.dashboard', {
      slug: defaultAnalyticsPage
    })
  }

  $scope.toggleSidebar = () => {
    $('.sidebar-menu').transition('slide right')
  }

  $scope.hideAppBannerText = () => {
    $scope.showAppBannerText = false
    UiElementViewLogService.createElementViewLog('appBannerText')
  }

  $scope.openModulesPricingDialog = (sendEvent, module) => {
    api.getModulesPricingDialogController().then(({ ModulesPricingDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: ModulesPricingDialogController,
        modalName: 'modulesPricingDialog',
        data: {
          module
        }
      })
      modal.open()
    })

    if (sendEvent) {
      SegmentService.track('pricing-plansfriction-menubanner-click')
    }
  }

  $scope.hideModulePriceInfoClick = () => {
    $scope.hideModulePricingInfo = true
  }

  $scope.showModulePricing = () => {
    if (!$rootScope.isUserSysAdminAdmin() || $scope.pricingPackageId !== 2) return false

    if (!$scope.features) return

    const hasWorkflow = $scope.features['WORKFLOW.ACCESS']
    const hasPosts = $scope.features['POSTS.ACCESS']
    const hasAnalytics = $scope.features['ANALYTICS.ACCESS']

    return !hasWorkflow || !hasPosts || !hasAnalytics
  }

  function _openAppBanner () {
    getAppBannerDialogController().then(({
      AppBannerModalController
    }) => {
      ModalService.showModal({
        autofocus: false,
        templateId: 'appBannerModal.html',
        templateUrl: '/core/dialogs/app-banner-modal/app-banner-modal.html?$$REVISION$$',
        destroyable: true,
        controller: AppBannerModalController,
        closable: true
      }).then(() => {
        const user = $rootScope.getUser()
        SegmentService.track('app-banner-viewed', {
          userId: user.id,
          customerCompanyId: user.customerCompanyId
        })
      })
    })
  }

  function _setSidebar (companyFeatures) {
    $scope.modules = {
      owned: [],
      pricing: []
    }

    if ($rootScope.isUserSysAdminAdminDesigner()) {
      $scope.modules.owned.push({
        label: $translate.instant('home'),
        icon: 'home',
        sref: 'home',
        onClick: $scope.handleFeatureClick,
        isActive: $scope.isActiveMenu.bind(this, 'home'),
        show: $scope.pricingPackageId !== 4
      })
    }

    const showCampaignModule = !!$scope.features['CAMPAIGNS.ACCESS']
    if (showCampaignModule) {
      $scope.modules.owned.push({
        label: $translate.instant('campaignsModule.title'),
        icon: 'target',
        sref: 'campaigns',
        onClick: $scope.handleFeatureClick,
        isActive: $scope.isActiveMenu.bind(this, 'campaigns'),
        show: !!$rootScope.isUserSysAdminAdmin()
      })
    }

    const shouldShowIAModule = $rootScope.isUserSysAdminAdminDesigner()
    if (shouldShowIAModule) {
      $scope.modules.owned.push({
        label: 'Mia',
        icon: 'ia',
        sref: 'ia',
        onClick: $scope.handleFeatureClick,
        isActive: $scope.isActiveMenu.bind(this, 'ia'),
        show: shouldShowIAModule
      })
    }

    if ($rootScope.isUserSysAdminAdminDesigner() && ($scope.features['WORKFLOW.ACCESS'] || $scope.features['CAMPAIGNS.ACCESS'])) {
      $scope.modules.owned.push({
        label: $translate.instant('calendar'),
        icon: 'calendar',
        sref: 'marketingCalendar',
        onClick: $scope.handleFeatureClick,
        isActive: () => $scope.isActiveMenu('marketingCalendar'),
        show: true
      })
    }

    $scope.modules.owned.push({
      label: $translate.instant('arts'),
      icon: 'arts',
      sref: 'arts.templates',
      onClick: $scope.handleFeatureClick,
      isActive: $scope.isModuleSubpage.bind(this, 'arts'),
      show: $scope.features['ARTS.ACCESS']
    })

    let arrayToAdd = $scope.features['WORKFLOW.ACCESS'] ? 'owned' : 'pricing'

    $scope.modules[arrayToAdd].push({
      label: $translate.instant('requests'),
      icon: 'workflow',
      onClick: $scope.changeToWorkflow,
      isActive: $scope.isModuleSubpage.bind(this, 'workflow'),
      show: $scope.features['WORKFLOW.ACCESS']
    })

    arrayToAdd = $scope.features['POSTS.ACCESS'] ? 'owned' : 'pricing'

    $scope.modules[arrayToAdd].push({
      label: $translate.instant('posts'),
      icon: 'posts',
      sref: 'posts',
      onClick: $scope.handleFeatureClick,
      isActive: $scope.isActiveMenu.bind(this, 'posts'),
      show: $scope.features['POSTS.ACCESS']
    })

    $scope.modules.owned.push({
      label: $translate.instant('checklist'),
      icon: 'audit',
      sref: $rootScope.isUserSysAdminAdminDesigner() && !$scope.features['CHECKLIST.ACCESS'] ? 'audit.socialMedia' : 'audit.list',
      show: $scope.pricingPackageId !== 4,
      onClick: $scope.handleFeatureClick,
      isActive: () => {
        return $scope.isActiveMenu('audit.list') || $scope.isActiveMenu('audit.models') || $scope.isActiveMenu('audit.socialMedia')
      }
    })

    $scope.modules.owned.push({
      label: $translate.instant('files'),
      icon: 'dam',
      sref: 'dam',
      onClick: $scope.handleFeatureClick,
      isActive: $scope.isActiveMenu.bind(this, 'dam'),
      show: api._enableFilesModule()
    }, {
      label: $translate.instant('repository.moduleTitle'),
      icon: 'dam',
      sref: 'repository.recents',
      onClick: $scope.handleFeatureClick,
      isActive: $scope.isModuleSubpage.bind(this, 'repository'),
      show: $rootScope.isUserSysAdminAdminDesigner() && !dontShowRepositories
    }, {
      label: $translate.instant('dashboard.brandSettings'),
      icon: 'brand',
      sref: 'brand',
      onClick: $scope.handleFeatureClick,
      isActive: $scope.isActiveMenu.bind(this, 'brand'),
      show: $scope.enableBrandModule()
    })

    arrayToAdd = $scope.features['ANALYTICS.ACCESS'] ? 'owned' : 'pricing'

    $scope.modules[arrayToAdd].push({
      label: $translate.instant('analytics'),
      icon: 'analytics',
      onClick: $scope.goToAnalytics,
      isActive: $scope.isModuleSubpage.bind(this, 'analytics'),
      show: $rootScope.isUserSysAdmin() || ($scope.features['ANALYTICS.ACCESS'] && $rootScope.isUserSysAdminAdmin())
    })

    api._setSidebarClass()
  }

  function _setSidebarClass () {
    if ($scope.modules.owned.length >= 6) {
      $('.sidebar-menu__content').addClass('condensed')
    }
  }

  $scope.openAppBanner = _openAppBanner

  $scope.goToKnowledgeBase = () => {
    const url = 'https://ajuda.deskfy.io/pt-BR/'
    $window.open(url, '_blank', 'noopener noreferrer')
  }

  $scope.openAskForSupport = () => {
    api.getAskForSupportDialogController().then(({ AskForSupportDialogController }) => {
      const askForSupportDialog = UdsModalService.createModal({
        controller: AskForSupportDialogController,
        modalName: 'askForSupportDialog'
      })
      askForSupportDialog.open()
    })
  }

  $scope.goToPrivacyPolicy = () => {
    const url = 'https://deskfy.io/politica-de-privacidade-deskfy/'
    $window.open(url, '_blank', 'noopener noreferrer')
  }

  $scope.getHeight = () => {
    return $('body').innerHeight()
  }

  $scope.$watch($scope.getHeight, (newHeight) => {
    const minimumScreenHeightPx = 875

    if (newHeight < minimumScreenHeightPx) {
      $scope.hideModulePriceInfoClick()
    }
  })
}

export { SidebarMenuController }
